import { __assign, __makeTemplateObject } from "tslib";
import React, { forwardRef } from 'react';
import MuiFormLabel from '@material-ui/core/FormLabel';
import { palette2, styled, typography, useThemeProps, } from '../../foundation';
var _RcFormLabel = React.memo(forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcFormLabel' });
    return React.createElement(MuiFormLabel, __assign({ ref: ref }, props));
}));
var RcFormLabel = styled(_RcFormLabel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), typography('subheading2'), palette2('interactive', 'f01'));
RcFormLabel.displayName = 'RcFormLabel';
export { RcFormLabel };
var templateObject_1;
